import { ConfigurationType } from '@server/parser';

//TODO fix ConfigurationItem imports in separate PR
import type { ConfigurationItem } from './ConfigurationItemTypes';
export * from './ConfigurationItemTypes';
export type { ConfigurationItem, ConfigurationItemBase } from './ConfigurationItemTypes';

// ******* BE types *******
export interface OpenAiResponse {
  data: string;
  error: string;
}

export type NameProperties = { name: string; label: string };

export interface LeadingFieldData {
  name: string;
  label: string;
  values: LeadingFieldValue[];
}

export type SfdcLeadStatusMetadata = {
  converted: boolean;
};

export type SfdcCaseStatusMetadata = {
  closed: boolean;
};

export enum OpportunityStageMetadataForecastCategory {
  COMMIT = 'Forecast', // label is Commit, value is Forecast
  OMITTED = 'Omitted',
  PIPELINE = 'Pipeline',
  BEST_CASE = 'BestCase', // label is `Best Case` value is BestCase
  CLOSED = 'Closed',
  MOST_LIKELY = 'MostLikely',
}

export type SfdcOpportunityStageMetadata = {
  won: boolean;
  closed: boolean;
  probability: number;
  forecastCategory: OpportunityStageMetadataForecastCategory;
};

export type SfdcStageMetadata =
  | SfdcCaseStatusMetadata
  | SfdcLeadStatusMetadata
  | SfdcOpportunityStageMetadata;

export type StageMetadataOptions = Partial<
  SfdcLeadStatusMetadata & SfdcCaseStatusMetadata & SfdcOpportunityStageMetadata
>;

export type LeadingFieldValue = NameProperties & {
  metadata?: { default: boolean } & StageMetadataOptions;
  [ParserBaseTypes.validationRules]?: string[];
  [ParserBaseTypes.flows]?: string[];
  [ParserBaseTypes.processBuilderFlows]?: string[];
  [ParserBaseTypes.workflowRules]?: string[];
  [ParserBaseTypes.approvalProcesses]?: string[];
};

// ----- client types -----
export interface RelatedObjectsMap {
  [objectName: string]: ConfigurationItem[];
}

export type FieldValue = {
  name: string;
  label: string;
  validationRules?: string[];
  flows?: string[];
  workflowRules?: string[];
  approvalProcesses?: string[];
  processBuilderFlows?: string[];
  apexTriggers?: string[]; //preparation for when supported by BE
  paths?: string[]; //preparation for when supported by BE
  cpqData?: string[];
  layouts?: string[];
};

export enum ParserBaseTypes {
  validationRules = 'validationRules',
  approvalProcesses = 'approvalProcesses',
  workflowRules = 'workflowRules',
  flows = 'flows',
  processBuilderFlows = 'processBuilderFlows',
  apexTriggers = 'apexTriggers',
  apexClasses = 'apexClasses',
  cpqData = 'cpqData',
  layouts = 'layouts',
}

export type OpenAiDescription = {
  type: 'error' | 'data';
  text: string;
};

//This type is for the API call: POST /parser  (the BE should unite the objectType types....)
export type ObjectType = {
  name: string;
  label?: string; //TBD if we need it here as we're displaying SF objects instead
  visible: boolean;
};

export type ParserItemsMap = {
  [type in ConfigurationType]: string[];
};

/**
 * ConfigurationItemWithStatus adds a status field to any configuration item type
 * while maintaining type safety from the discriminated union.
 */
export type ConfigurationItemWithStatus = ConfigurationItem & {
  status: 'Active' | 'Inactive';
};
